import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router"
@Component({
  selector: 'app-devices-screen',
  templateUrl: './devices-screen.component.html',
  styleUrls: ['./devices-screen.component.scss']
})
export class DevicesScreenComponent implements OnInit {

  constructor(private router: Router) {}
  ngOnInit(): void {
  }
  redirectConnect():void{
    this.router.navigate(['/connect'])
  }
}
